(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    const drawer = document.getElementById('cart-drawer');
    const body = document.getElementById('cart-drawer-body');
    const openTriggers = document.querySelectorAll('[data-cart-drawer-open]');
    const closeTriggers = document.querySelectorAll('[data-cart-drawer-close]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function updateCartUI(cart) {
      let itemsContainer = document.getElementById('cart-drawer-items');
      const emptyState = document.getElementById('cart-drawer-empty');
      let footer = drawer?.querySelector('.cart-drawer__footer');
      const totalEl = document.getElementById('cart-drawer-total');
      const countEl = document.querySelector('.header-main__cart-count');

      if (!drawer || !body) return;

      if (cart.item_count === 0) {
        if (itemsContainer) itemsContainer.style.display = 'none';
        if (footer) footer.style.display = 'none';
        if (emptyState) {
          emptyState.style.display = 'flex';
        }
        if (countEl) countEl.remove();
      } else {
        if (emptyState) emptyState.style.display = 'none';

        var i18n = window.cartDrawerI18n || {};
        var urls = window.cartDrawerUrls || { cart: '/cart', checkout: '/checkout' };
        if (!itemsContainer) {
          itemsContainer = document.createElement('div');
          itemsContainer.id = 'cart-drawer-items';
          itemsContainer.className = 'cart-drawer__items';
          body.insertBefore(itemsContainer, body.firstChild);
        }
        if (!footer) {
          footer = document.createElement('footer');
          footer.className = 'cart-drawer__footer';
          footer.innerHTML = '<div class="cart-drawer__subtotal"><span>' + (i18n.subtotal || 'Subtotal') + '</span><span id="cart-drawer-total"></span></div>' +
            '<div class="cart-drawer__pix"><span>' + (i18n.pix_total || 'No PIX') + '</span><span id="cart-drawer-pix"></span></div>' +
            '<button type="button" class="cart-drawer__btn cart-drawer__btn--continue" data-cart-drawer-close>' + (i18n.continue_shopping || 'Continuar comprando') + '</button>' +
            '<a href="' + urls.cart + '" class="cart-drawer__btn cart-drawer__btn--secondary">' + (i18n.view_cart || 'View cart') + '</a>' +
            '<a href="' + urls.checkout + '" class="cart-drawer__btn cart-drawer__btn--primary">' + (i18n.checkout || 'Checkout') + '</a>';
          body.appendChild(footer);
        }
        if (footer) footer.style.display = 'flex';

        var removeLabel = i18n.remove || 'Remove';
        var increaseLabel = i18n.increase || 'Increase';
        var decreaseLabel = i18n.decrease || 'Decrease';
        var itemsHTML = '';
        cart.items.forEach(function(item, i) {
          var line = i + 1;
          var imgTag = item.image
            ? '<img src="' + item.image + '" alt="" class="cart-drawer__item-img" loading="lazy">'
            : '<div class="cart-drawer__item-placeholder"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg></div>';
          itemsHTML += '<div class="cart-drawer__item" data-line="' + line + '">' +
            '<a href="' + item.url + '" class="cart-drawer__item-image">' + imgTag + '</a>' +
            '<div class="cart-drawer__item-details">' +
              '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
              (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
              '<div class="cart-drawer__item-row">' +
                '<div class="cart-drawer__qty">' +
                  '<button type="button" class="cart-drawer__qty-btn" data-cart-change="' + line + '" data-quantity="' + (item.quantity - 1) + '" aria-label="' + decreaseLabel + '">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg>' +
                  '</button>' +
                  '<span class="cart-drawer__qty-value" data-quantity-display>' + item.quantity + '</span>' +
                  '<button type="button" class="cart-drawer__qty-btn" data-cart-change="' + line + '" data-quantity="' + (item.quantity + 1) + '" aria-label="' + increaseLabel + '">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>' +
                  '</button>' +
                '</div>' +
                '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
              '<button type="button" class="cart-drawer__item-remove" data-cart-remove="' + line + '" aria-label="' + removeLabel + '">' + removeLabel + '</button>' +
            '</div>' +
          '</div>';
        });

        if (itemsContainer) {
          itemsContainer.innerHTML = itemsHTML;
          itemsContainer.style.display = 'flex';
        }

        // Re-consulta: o footer pode ter sido criado agora, depois da leitura do topo da função
        var totalNode = totalEl || document.getElementById('cart-drawer-total');
        if (totalNode) totalNode.textContent = formatMoney(cart.total_price);

        // cart.total_price já vem com o desconto do módulo aplicado pela Shopify;
        // aqui aplicamos o segundo passo da cascata (extra do PIX), igual ao checkout.
        var pixNode = document.getElementById('cart-drawer-pix');
        if (pixNode) {
          var pixExtra = parseInt(drawer.getAttribute('data-pix-extra'), 10);
          if (isNaN(pixExtra)) pixExtra = 5;
          pixNode.textContent = formatMoney(Math.floor(cart.total_price * (100 - pixExtra) / 100));
        }

        const iconWrap = document.querySelector('.header-main__icon-wrap');
        if (iconWrap) {
          let badge = iconWrap.querySelector('.header-main__cart-count');
          if (cart.item_count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'header-main__cart-count';
              badge.setAttribute('aria-hidden', 'true');
              iconWrap.appendChild(badge);
            }
            badge.textContent = cart.item_count;
          } else if (badge) {
            badge.remove();
          }
        }
      }
    }

    function escapeHtml(s) {
      const div = document.createElement('div');
      div.textContent = s;
      return div.innerHTML;
    }

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function fetchCart() {
      return fetch('/cart.js').then(function(r) { return r.json(); });
    }

    function changeQuantity(line, quantity) {
      const item = drawer.querySelector('.cart-drawer__item[data-line="' + line + '"]');
      if (item) item.classList.add('is-updating');

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateCartUI(cart);
          return cart;
        })
        .catch(function(err) {
          console.error('Cart update error:', err);
          return fetchCart().then(updateCartUI);
        })
        .finally(function() {
          if (item) item.classList.remove('is-updating');
        });
    }

    openTriggers.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });

    closeTriggers.forEach(function(btn) {
      btn.addEventListener('click', closeDrawer);
    });

    drawer?.addEventListener('click', function(e) {
      if (e.target === drawer) closeDrawer();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer();
    });

    body?.addEventListener('click', function(e) {
      const changeBtn = e.target.closest('[data-cart-change]');
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (changeBtn) {
        const line = parseInt(changeBtn.dataset.cartChange, 10);
        const qty = parseInt(changeBtn.dataset.quantity, 10);
        if (qty >= 0) changeQuantity(line, qty);
      } else if (removeBtn) {
        const line = parseInt(removeBtn.dataset.cartRemove, 10);
        changeQuantity(line, 0);
      }
    });

    document.addEventListener('cart:refresh', function() {
      fetchCart().then(updateCartUI);
    });

    document.addEventListener('cart:openAfterAdd', function() {
      fetchCart()
        .then(updateCartUI)
        .then(function() { openDrawer(); })
        .catch(function() { openDrawer(); });
    });

    function openDrawerFromAdd() {
      fetchCart()
        .then(updateCartUI)
        .then(function() { openDrawer(); })
        .catch(function() { openDrawer(); });
    }

    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || (typeof form.action === 'string' && form.action.indexOf('/cart/add') === -1)) return;
      if (form.hasAttribute('data-ajax-add-disabled')) return;
      if (e.submitter && e.submitter.name !== 'add' && e.submitter.getAttribute('name') !== 'add') return;

      e.preventDefault();
      var variantInput = form.querySelector('[name="id"]');
      var quantityInput = form.querySelector('[name="quantity"]');
      if (!variantInput || !variantInput.value) {
        form.submit();
        return;
      }

      var variantId = parseInt(variantInput.value, 10);
      var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      var items = [{ id: variantId, quantity: quantity }];

      var props = {};
      form.querySelectorAll('[name^="properties["]').forEach(function(input) {
        var m = input.name.match(/properties\[(.+)\]/);
        if (m && input.value) props[m[1]] = input.value;
      });
      if (Object.keys(props).length) items[0].properties = props;

      var btn = form.querySelector('[type="submit"][name="add"]');
      var originalText = btn ? btn.innerHTML : '';
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function(r) { return r.json().then(function(data) { return { ok: r.ok, data: data }; }); })
        .then(function(result) {
          if (result.ok) {
            // Notifica o SyndiTag (e outros listeners) sobre o item adicionado
            var addedItem = result.data && result.data.items && result.data.items[0];
            if (addedItem) {
              document.dispatchEvent(new CustomEvent('cart:itemAdded', {
                detail: {
                  sku:   addedItem.sku || '',
                  qty:   addedItem.quantity || 1,
                  price: ((addedItem.price || 0) / 100).toFixed(2)
                }
              }));
            }
            openDrawerFromAdd();
          } else {
            var msg = result.data && result.data.description ? result.data.description : (result.data && result.data.message) || 'Erro ao adicionar';
            alert(msg);
          }
        })
        .catch(function() {
          form.setAttribute('data-ajax-add-disabled', '');
          form.submit();
        })
        .finally(function() {
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
        });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-nav"] && !Shopify.designMode) return;
  try {
    (function() {
    var nav    = document.getElementById('main-nav');
    var header = document.querySelector('.header-main');
    if (!nav || !header) return;

    /*
     * hiddenAt: viewport width (px) where the nav was hidden.
     * The nav only re-appears when the viewport grows >= hiddenAt + HYST,
     * preventing the oscillation loop caused by layout shifts.
     */
    var hiddenAt = null;
    var HYST     = 60; /* hysteresis gap in px */
    var timer;

    function checkFit() {
      var isHidden = nav.classList.contains('main-nav--hidden');

      if (!isHidden) {
        /* Nav is visible — measure real overflow */
        var list  = nav.querySelector('.main-nav__list');
        var inner = nav.querySelector('.main-nav__inner');
        if (!list || !inner) return;

        if (list.scrollWidth > inner.clientWidth + 2) {
          hiddenAt = window.innerWidth;
          nav.classList.add('main-nav--hidden');
          header.classList.add('header-main--show-toggle');
        }
      } else {
        /* Nav is hidden — only attempt to restore if viewport grew enough */
        if (hiddenAt === null || window.innerWidth >= hiddenAt + HYST) {
          nav.classList.remove('main-nav--hidden');
          header.classList.remove('header-main--show-toggle');

          /* Re-check immediately: maybe it still overflows at this width */
          var list  = nav.querySelector('.main-nav__list');
          var inner = nav.querySelector('.main-nav__inner');
          if (list && inner && list.scrollWidth > inner.clientWidth + 2) {
            hiddenAt = window.innerWidth;
            nav.classList.add('main-nav--hidden');
            header.classList.add('header-main--show-toggle');
          } else {
            hiddenAt = null;
          }
        }
      }
    }

    /* Debounced resize — window.resize only fires on viewport change,
       not on DOM mutations, so no infinite loop risk. */
    window.addEventListener('resize', function() {
      clearTimeout(timer);
      timer = setTimeout(checkFit, 40);
    });

    /* Initial check */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkFit);
    } else {
      checkFit();
    }
  })();

  /* ─── Mega Menu hover interaction ─────────────────────────────── */
  (function() {
    function initMegaMenus() {
      document.querySelectorAll('.main-nav__panel--mega').forEach(function(panel) {
        var items = Array.from(panel.querySelectorAll('.mega-menu__sidebar-item'));
        var panes = Array.from(panel.querySelectorAll('.mega-menu__pane'));

        function activate(idx) {
          items.forEach(function(el, i) {
            el.classList.toggle('mega-menu__sidebar-item--active', i === idx);
          });
          panes.forEach(function(el, i) {
            el.classList.toggle('mega-menu__pane--active', i === idx);
          });
        }

        items.forEach(function(item, idx) {
          item.addEventListener('mouseenter', function() { activate(idx); });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMegaMenus);
    } else {
      initMegaMenus();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-local-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
    const config = document.querySelector('[data-local-delivery-config]');
    const appBlock = document.querySelector('[id*="frete_no_produto"]');
    if (!config || !appBlock) return;

    const LOCAL_CITY = 'maringa';
    const LOCAL_UF = 'PR';
    const RESULTS_ID = 'calc-carrier';
    const ZIPCODE_ID = 'zipcode';
    const CALCULATE_BUTTON_SELECTOR = '#formKokfyShipping .btnForm';
    const OPTION_SELECTOR = '[data-local-delivery-option]';

    const localCepCache = new Map();

    const normalizeCep = (value) => (value || '').replace(/\D/g, '');

    const normalizeText = (value) =>
      (value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();

    const getTypedCep = () => {
      const input = document.getElementById(ZIPCODE_ID);
      const cep = normalizeCep(input && input.value);
      return cep.length === 8 ? cep : null;
    };

    const isLocalDeliveryCep = (cep) => {
      if (localCepCache.has(cep)) return localCepCache.get(cep);

      const request = fetch('https://viacep.com.br/ws/' + cep + '/json/')
        .then((response) => (response.ok ? response.json() : null))
        .then((data) =>
          Boolean(data && !data.erro && data.uf === LOCAL_UF && normalizeText(data.localidade) === LOCAL_CITY)
        )
        .catch(() => {
          localCepCache.delete(cep);
          return false;
        });

      localCepCache.set(cep, request);
      return request;
    };

    const createElement = (tagName, className, text) => {
      const element = document.createElement(tagName);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    };

    const buildLocalDeliveryItem = () => {
      const item = createElement('li', 'local-delivery-option');
      item.setAttribute('data-local-delivery-option', '');
      item.setAttribute('aria-label', config.dataset.ariaLabel);

      const info = createElement('div', 'ship-name local-delivery-option__info');
      info.append(
        createElement('span', 'local-delivery-option__badge', config.dataset.badge),
        createElement('span', 'local-delivery-option__name', config.dataset.name)
      );

      item.append(info, createElement('span', 'ship-price local-delivery-option__price', config.dataset.price));
      return item;
    };

    const canInjectInto = (container) =>
      Boolean(container) && container.childElementCount > 0 && !container.querySelector(OPTION_SELECTOR);

    const injectLocalDelivery = (container) => {
      const item = buildLocalDeliveryItem();
      const list = container.querySelector('ul');
      if (list) {
        list.prepend(item);
        return;
      }

      const newList = createElement('ul');
      newList.append(item);
      container.prepend(newList);
    };

    const handleResultsChange = async () => {
      if (!canInjectInto(document.getElementById(RESULTS_ID))) return;

      const cep = getTypedCep();
      if (!cep) return;

      const isLocal = await isLocalDeliveryCep(cep);
      if (!isLocal || getTypedCep() !== cep) return;

      const container = document.getElementById(RESULTS_ID);
      if (!canInjectInto(container)) return;

      injectLocalDelivery(container);
    };

    const handleCalculateClick = (event) => {
      if (!(event.target instanceof Element) || !event.target.closest(CALCULATE_BUTTON_SELECTOR)) return;

      const cep = getTypedCep();
      if (cep) isLocalDeliveryCep(cep);
    };

    document.addEventListener('click', handleCalculateClick, true);
    new MutationObserver(handleResultsChange).observe(appBlock, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
